import React from "react";
import { formatMatterportURL, formatSmartViewMedia, formatVimeoURL, formatVirtualToursCreatorURL, formatYouTubeURL, getEmbedURL } from "~/helpers/EmbedURLHelper";


type VideoEmbedProps = {
    url: string;
    height?: number;
};




const VideoEmbedSection: React.FC<VideoEmbedProps> = ({ url, height }) => {
    if (!url) {
        return null;
    }

    const embedURL = getEmbedURL(url);

    if (embedURL) {
        return (
            <iframe
                width='100%'
                height={`${height}px`}
                allowFullScreen
                src={embedURL}
                loading="lazy"
                data-nosnippet="true"
                className='rounded-lg overflow-hidden'
                sandbox="allow-scripts allow-same-origin allow-presentation"
                referrerPolicy="origin-when-cross-origin"
            />
        );
    }

    return null;
};

export default VideoEmbedSection;